// extracted by mini-css-extract-plugin
export default {"pageLayout":"ta-z","mainContent":"ua-z","columnLayout":"va-z","columnLayoutFill":"wa-z","columnLayoutLast":"xa-z"};